import produce from 'immer';
import {
  USER_LOGOUT_START,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAILED,
  USER_SIGNUP_ONELOGIN_START,
  USER_SIGNUP_ONELOGIN_SUCCESS,
  USER_SIGNUP_ONELOGIN_FAILED,
  GET_USER_PROFILE_START,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAILED,
  CREDIT_BALANCE_START,
  CREDIT_BALANCE_SUCCESS,
  CREDIT_BALANCE_FAILED,
  CREDIT_HISTORY_START,
  CREDIT_HISTORY_SUCCESS,
  CREDIT_HISTORY_FAILED,
  GET_USER_CREDIT_CARDS_START,
  GET_USER_CREDIT_CARDS_SUCCESS,
  GET_USER_CREDIT_CARDS_FAILED,
  REPLACE_USER_CREDIT_CARD_START,
  REPLACE_USER_CREDIT_CARD_SUCCESS,
  REPLACE_USER_CREDIT_CARD_FAILED,
  DELETE_USER_CREDIT_CARD_START,
  DELETE_USER_CREDIT_CARD_SUCCESS,
  DELETE_USER_CREDIT_CARD_FAILED,
  CREATE_SUBSCRIPTION_TIER_START,
  CREATE_SUBSCRIPTION_TIER_SUCCESS,
  CREATE_SUBSCRIPTION_TIER_FAILED,
  UPDATE_SUBSCRIPTION_TIER_START,
  UPDATE_SUBSCRIPTION_TIER_SUCCESS,
  UPDATE_SUBSCRIPTION_TIER_FAILED,
  DELETE_SUBSCRIPTION_TIER_START,
  DELETE_SUBSCRIPTION_TIER_SUCCESS,
  DELETE_SUBSCRIPTION_TIER_FAILED,
  GET_TIER_SUBSCRIPTION_PLANS_START,
  GET_TIER_SUBSCRIPTION_PLANS_SUCCESS,
  GET_TIER_SUBSCRIPTION_PLANS_FAILED,
  EDIT_USER_SUBSCRIPTION_PLAN,
  CANCEL_EDIT_USER_SUBSCRIPTION_PLAN,
  UPDATE_USER_SUBSCRIPTION_PLAN_START,
  UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS,
  UPDATE_USER_SUBSCRIPTION_PLAN_FAILED,
  UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_START,
  UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS,
  UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED,
  CREATE_CUSTOMER_ACCOUNT_START,
  CREATE_CUSTOMER_ACCOUNT_SUCCESS,
  CREATE_CUSTOMER_ACCOUNT_FAILED,
  REQUEST_TAX_RATES_CONFIGURATIONS_START,
  REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS,
  REQUEST_TAX_RATES_CONFIGURATIONS_FAILED,
  USER_PROFILE_UPDATE_START,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_FAILED,
  CHANGE_ACTIVE_STORE_START,
  CHANGE_ACTIVE_STORE_SUCCESS,
  CHANGE_ACTIVE_STORE_FAILED,
  BUY_SUBSCRIPTION_ADDON_START,
  BUY_SUBSCRIPTION_ADDON_SUCCESS,
  BUY_SUBSCRIPTION_ADDON_FAILED,
  GET_ACTIVE_STORE_USERS_START,
  GET_ACTIVE_STORE_USERS_SUCCESS,
  GET_ACTIVE_STORE_USERS_FAILED,
  REFRESH_TOKEN_START,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILED,
} from '../actions/user';
import {
  SET_USERS,
  SET_USERS_START,
  SET_USERS_FAILED,
  SAVE_EDITED_STORE_START,
  SAVE_EDITED_STORE_SUCCESS,
  SAVE_EDITED_STORE_FAILED,
  UPDATE_PERMISSION_CONFIG_SUCCESS,
  DELETE_USER_STORE_SUCCESS,
  ADD_USER_STORE_SUCCESS
} from '../actions/admin';


const initialState = {
  profile: {},
  userPermissions: {},
  userStoreData: {},
  userStoreIsCreated: false,
  currentStoreUsersEmails: [],
  isLoggedIn: false,
  signingUp: false,
  error: '',
  usersInitialState: [],
  users: [],
  usersToUpdateSubscriptionPlan: {},
  pointBalance: 0,
  creditHistory: {
    items: [],
    count: 0
  },
  userCreditCards: [],
  subscriptionTiers: [],
  activeStoreUsers: [],
  loadingUserCreditCards: false,
  loadingTierPlans: false,
  loadingProfile: false,
  loadingBalance: false,
  loadingHistory: false,
  loggingOut: false,
  loadingSaveTierPlan: false,
  loadingUsers: false,
  loadingUpdateUserPlans: false,
  loadingUpdateCurrentUserPlan: false,
  creatingCustomerAccount: false,
  loadingRequestTaxRAtesConfigurations: false,
  buyingSubscriptionAddon: false,
  loadingActiveStoreUsers: false,
  savingOnboardingData: false,
  isRefreshingToken: false
};


const formReducer = produce((state: IUserState = initialState, action) => {
  switch (action.type) {
    case SET_USERS_START: {
      state.loadingUsers = true;
      break;
    }

    case SET_USERS: {
      const {data} = action;
      state.users = data.users;
      state.currentStoreUsersEmails = data.users.reduce((prev: string[], curr) => {
        if (curr.stores[0]?.storeUrl === state.profile?.stores[0]?.storeUrl) {
          prev.push(curr.email);
        }

        return prev;
      }, []);
      state.usersInitialState = data.users;
      state.loadingUsers = false;
      break;
    }

    case SET_USERS_FAILED: {
      state.loadingUsers = false;
      break;
    }

    case USER_LOGOUT_START: {
      state.loggingOut = true;
      break;
    }

    case USER_LOGOUT_SUCCESS: {
      state.profile = initialState.profile;
      state.loggingOut = false;
      break;
    }

    case USER_LOGOUT_FAILED: {
      state.loggingOut = false;
      break;
    }

    case USER_SIGNUP_ONELOGIN_START: {
      state.signingUp = true;
      break;
    }

    case USER_SIGNUP_ONELOGIN_SUCCESS: {
      state.signingUp = false;
      window.location.href = '/';
      break;
    }

    case USER_SIGNUP_ONELOGIN_FAILED: {
      state.signingUp = false;
      break;
    }

    case GET_USER_PROFILE_START: {
      state.loadingProfile = true;
      break;
    }

    case GET_USER_PROFILE_SUCCESS: {
      const {user} = action.data;
      state.profile = user;
      state.userStoreData = user.stores.length ? user.stores[0] : {};

      state.currentStoreUsersEmails = state.users.reduce((prev, curr) => {
        if (curr.stores[0]?.storeUrl === user.stores[0].storeUrl) {
          prev.push(curr.email);
        }

        return prev;
      }, []);

      if (user.stores.length) {
        state.userStoreIsCreated = user.stores[0].isCreated;
      }

      if (user?.config?.permissions) {
        state.userPermissions = user.config.permissions;
      }

      state.loadingProfile = false;
      break;
    }

    case GET_USER_PROFILE_FAILED: {
      state.loadingProfile = false;
      break;
    }

    case CREDIT_BALANCE_START: {
      state.loadingBalance = true;
      break;
    }

    case CREDIT_BALANCE_SUCCESS: {
      const {data} = action;
      state.pointBalance = data.pointBalance;
      state.loadingBalance = false;
      break;
    }

    case CREDIT_BALANCE_FAILED: {
      state.loadingBalance = false;
      break;
    }

    case CREDIT_HISTORY_START: {
      state.loadingHistory = true;
      break;
    }

    case CREDIT_HISTORY_SUCCESS: {
      const {data} = action;
      state.creditHistory.items = data.items;
      state.creditHistory.count = data.total_count;
      state.loadingHistory = false;
      break;
    }

    case CREDIT_HISTORY_FAILED: {
      state.loadingHistory = false;
      break;
    }

    case GET_USER_CREDIT_CARDS_START: {
      state.loadingUserCreditCards = true;
      break;
    }

    case GET_USER_CREDIT_CARDS_SUCCESS: {
      const {data} = action;
      state.userCreditCards = data;
      state.loadingUserCreditCards = false;
      break;
    }

    case GET_USER_CREDIT_CARDS_FAILED: {
      state.loadingUserCreditCards = false;
      break;
    }

    case REPLACE_USER_CREDIT_CARD_START: {
      state.loadingUserCreditCards = true;
      break;
    }

    case REPLACE_USER_CREDIT_CARD_SUCCESS: {
      state.loadingUserCreditCards = false;
      break;
    }

    case REPLACE_USER_CREDIT_CARD_FAILED: {
      state.loadingUserCreditCards = false;
      break;
    }

    case DELETE_USER_CREDIT_CARD_START: {
      state.loadingUserCreditCards = true;
      break;
    }

    case DELETE_USER_CREDIT_CARD_SUCCESS: {
      const {id} = action;
      state.userCreditCards = state.userCreditCards.filter((card) => card.master_id !== id);
      state.loadingUserCreditCards = false;
      break;
    }

    case DELETE_USER_CREDIT_CARD_FAILED: {
      state.loadingUserCreditCards = false;
      break;
    }

    case GET_TIER_SUBSCRIPTION_PLANS_START: {
      state.loadingTierPlans = true;
      break;
    }

    case GET_TIER_SUBSCRIPTION_PLANS_SUCCESS: {
      const {data} = action;
      state.subscriptionTiers = data.subscriptionTiers;
      state.loadingTierPlans = false;
      break;
    }

    case GET_TIER_SUBSCRIPTION_PLANS_FAILED: {
      state.loadingTierPlans = false;
      break;
    }

    case CREATE_SUBSCRIPTION_TIER_START: {
      state.loadingSaveTierPlan = true;
      break;
    }
    case CREATE_SUBSCRIPTION_TIER_SUCCESS: {
      const {data} = action;
      state.subscriptionTiers = [...state.subscriptionTiers, data.subscriptionTier];
      state.loadingSaveTierPlan = false;
      break;
    }
    case CREATE_SUBSCRIPTION_TIER_FAILED: {
      state.loadingSaveTierPlan = false;
      break;
    }

    case UPDATE_SUBSCRIPTION_TIER_START: {
      state.loadingSaveTierPlan = true;
      break;
    }
    case UPDATE_SUBSCRIPTION_TIER_SUCCESS: {
      const {subscriptionTier} = action.data;
      state.subscriptionTiers = state.subscriptionTiers.map((t) => t._id === subscriptionTier._id ? subscriptionTier : t);

      state.loadingSaveTierPlan = false;
      break;
    }
    case UPDATE_SUBSCRIPTION_TIER_FAILED: {
      state.loadingSaveTierPlan = false;
      break;
    }

    case DELETE_SUBSCRIPTION_TIER_START: {
      state.loadingSaveTierPlan = true;
      break;
    }
    case DELETE_SUBSCRIPTION_TIER_SUCCESS: {
      const {id} = action;
      state.subscriptionTiers = state.subscriptionTiers.filter((t) => t._id !== id);
      state.loadingSaveTierPlan = false;
      break;
    }
    case DELETE_SUBSCRIPTION_TIER_FAILED: {
      state.loadingSaveTierPlan = false;
      break;
    }

    case EDIT_USER_SUBSCRIPTION_PLAN: {
      const {actionName, option, editedPlanId, editedPlanTierId} = action;

      if (actionName === 'remove-option') {
        state.users = state.users.map((user) => user.email === option.option.email
          ?
          {...user, subscriptionId: null}
          : user
        );
        state.usersToUpdateSubscriptionPlan[option.option._id] =
          {
            userId: option.option._id,
            storeId: option.option.stores[0]._id,
            planId: null,
            tierId: null
          };
      }

      if (actionName === 'select-option') {
        state.users = state.users.map((user) => user.email === option.option.email
          ?
          {...user, subscriptionId: editedPlanId}
          : user
        );
        state.usersToUpdateSubscriptionPlan[option.option._id] =
          {
            userId: option.option._id,
            storeId: option.option.stores[0]._id,
            planId: editedPlanId,
            tierId: editedPlanTierId
          };
      }

      break;
    }
    case CANCEL_EDIT_USER_SUBSCRIPTION_PLAN: {
      state.users = state.usersInitialState;
      break;
    }

    case UPDATE_USER_SUBSCRIPTION_PLAN_START: {
      state.loadingUpdateUserPlans = true;
      break;
    }

    case UPDATE_USER_SUBSCRIPTION_PLAN_SUCCESS: {
      const {results} = action;

      const userObjects = results.map((res) => res.value.data.user);

      userObjects.forEach((user) => {
        state.users = state.users.map((u) => {
          return u._id === user._id ? user : u;
        });
      });

      state.usersToUpdateSubscriptionPlan = initialState.usersToUpdateSubscriptionPlan;
      state.loadingUpdateUserPlans = false;

      break;
    }

    case UPDATE_USER_SUBSCRIPTION_PLAN_FAILED: {
      state.loadingUpdateUserPlans = false;
      break;
    }

    case UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_START: {
      state.loadingUpdateCurrentUserPlan = true;
      break;
    }

    case UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_SUCCESS: {
      const {user} = action.data;

      state.profile = user;
      state.loadingUpdateCurrentUserPlan = false;

      break;
    }

    case UPDATE_CURRENT_USER_SUBSCRIPTION_PLAN_FAILED: {
      state.loadingUpdateCurrentUserPlan = false;
      break;
    }

    case CREATE_CUSTOMER_ACCOUNT_START: {
      state.creatingCustomerAccount = true;
      break;
    }

    case CREATE_CUSTOMER_ACCOUNT_SUCCESS: {
      const {user} = action.data;
      const initials = `${
        user?.firstName ? user?.firstName?.charAt(0).toUpperCase() : ''
      }${
        user?.lastName ? user?.lastName?.charAt(0).toUpperCase() : ''
      }`;

      const newUser = {
        initials,
        name: `${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}`,
        email: user?.email
      };

      state.activeStoreUsers = [...state.activeStoreUsers, newUser];
      state.creatingCustomerAccount = false;

      break;
    }

    case CREATE_CUSTOMER_ACCOUNT_FAILED: {
      state.creatingCustomerAccount = false;
      break;
    }

    case REQUEST_TAX_RATES_CONFIGURATIONS_START: {
      state.loadingRequestTaxRAtesConfigurations = true;
      break;
    }

    case REQUEST_TAX_RATES_CONFIGURATIONS_SUCCESS: {
      state.loadingRequestTaxRAtesConfigurations = false;

      break;
    }

    case REQUEST_TAX_RATES_CONFIGURATIONS_FAILED: {
      state.loadingRequestTaxRAtesConfigurations = false;
      break;
    }

    case USER_PROFILE_UPDATE_START: {
      state.loadingProfile = true;
      break;
    }

    case USER_PROFILE_UPDATE_SUCCESS: {
      const { data } = action;

      if (state.profile._id === data.user._id) {
        state.profile = {...state.profile, ...data.user};
      }

      state.loadingProfile = false;
      break;
    }

    case USER_PROFILE_UPDATE_FAILED: {
      state.loadingProfile = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_START: {
      state.loadingProfile = true;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      const { user } = action.data;

      if (state.profile._id === user._id) {
        state.profile = user;
        // eslint-disable-next-line prefer-destructuring
        state.userStoreData = user.stores[0];
      }

      state.loadingProfile = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_FAILED: {
      state.loadingProfile = false;
      break;
    }

    case SAVE_EDITED_STORE_START: {
      state.loadingProfile = true;
      break;
    }

    case SAVE_EDITED_STORE_SUCCESS: {
      const { store } = action.data;
      state.profile.stores = state.profile.stores.map((s) => s._id === store._id ? store : s);
      [state.userStoreData] = state.profile.stores;
      state.loadingProfile = false;
      break;
    }

    case SAVE_EDITED_STORE_FAILED: {
      state.loadingProfile = false;
      break;
    }

    case UPDATE_PERMISSION_CONFIG_SUCCESS: {
      const { config } = action.data;

      if (state.profile.config?._id === config?._id) {
        state.profile.config = config;
      }

      break;
    }

    case BUY_SUBSCRIPTION_ADDON_START: {
      state.buyingSubscriptionAddon = true;
      break;
    }

    case BUY_SUBSCRIPTION_ADDON_SUCCESS: {
      const { data } = action;

      if (state.profile._id === data.user._id) {
        state.profile = {...state.profile, ...data.user};
      }

      state.buyingSubscriptionAddon = false;
      break;
    }

    case BUY_SUBSCRIPTION_ADDON_FAILED: {
      state.buyingSubscriptionAddon = false;
      break;
    }

    case GET_ACTIVE_STORE_USERS_START: {
      state.loadingActiveStoreUsers = true;
      break;
    }

    case GET_ACTIVE_STORE_USERS_SUCCESS: {
      const { data } = action;

      state.activeStoreUsers = data.users
        .map((user) => {
          const initials = `${
            user?.firstName ? user?.firstName?.charAt(0).toUpperCase() : ''
          }${
            user?.lastName ? user?.lastName?.charAt(0).toUpperCase() : ''
          }`;

          return ({
            initials,
            name: `${user.firstName ? user.firstName : ''} ${user.lastName ? user.lastName : ''}`,
            email: user?.email,
            id: user?._id
          });
        });
      state.loadingActiveStoreUsers = false;
      break;
    }

    case GET_ACTIVE_STORE_USERS_FAILED: {
      state.loadingActiveStoreUsers = false;
      break;
    }

    case DELETE_USER_STORE_SUCCESS: {
      const { data: { email, apiUrl } } = action;

      // Remove from activeStoreUsers
      state.activeStoreUsers = state.activeStoreUsers.filter((user) => user.email !== email);

      // If this is the current user's store being removed
      if (email === state.profile.email) {
        // Remove the store from profile.stores
        state.profile.stores = state.profile.stores.filter((s) => s.apiUrl !== apiUrl);

        // Only update userStoreData if we deleted the currently active store
        if (state.userStoreData?.apiUrl === apiUrl) {
          state.userStoreData = state.profile.stores.length > 0 ? state.profile.stores[0] : {};
          state.userStoreIsCreated = state.profile.stores.length > 0 ? !!state.profile.stores[0].isCreated : false;
        }
      }

      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      const { userEmail, store } = action.data;

      if (userEmail === state.profile.email) {
        state.profile.stores.unshift(store);

        state.userStoreData = store;
        state.userStoreIsCreated = !!store?.isCreated;
      }

      break;
    }

    case REFRESH_TOKEN_START: {
      state.isRefreshingToken = true;
      break;
    }

    case REFRESH_TOKEN_SUCCESS: {
      state.isRefreshingToken = false;
      break;
    }

    case REFRESH_TOKEN_FAILED: {
      state.profile = initialState.profile;
      state.isRefreshingToken = false;
      break;
    }


    default:
      break;
  }
}, initialState);

export default formReducer;
